/** 后台 API 的同源版本前缀，服务、验证码图片和导出入口共用。 */
export const ADMIN_API_PREFIX = '/api/admin/v1';
